import React from 'react';
import ReactLoading from 'react-loading';

export const Loading = ({ type, color }) => (
  <div id='loading' className='d-flex'>
    <ReactLoading type='spin' color={color} width={100} />
  </div>
);